module.exports = __webpack_public_path__ + "img/DNADamage-BRCA_10X_Section1.244e8df6.png";